import { getFirstLastMsgIndicesFromSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { SummaryMetadata } from 'generated/graphql';
import { AudioConversationMessage } from 'v2/core/entities/feedback/content';

export const getStartEndTimeFromAudioSummaryMetadata = (
  metadata: SummaryMetadata | undefined,
  audioConversation: AudioConversationMessage[],
) => {
  const { firstMsgIndex, lastMsgIndex } =
    getFirstLastMsgIndicesFromSummaryMetadata(metadata);

  return {
    startTime: audioConversation[firstMsgIndex]?.metadata.startTime ?? 0,
    endTime: audioConversation[lastMsgIndex]?.metadata.endTime ?? 0,
  };
};
